"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.withEnterKey = function (Component) { return function (props) {
    var onEnter = props.onEnter, onKeyPress = props.onKeyPress, rest = __rest(props, ["onEnter", "onKeyPress"]);
    var handleOnKeyPress = function (e) {
        e.stopPropagation();
        if (onKeyPress) {
            onKeyPress(e);
        }
        if (onEnter && e.key === 'Enter') {
            onEnter(e);
        }
    };
    return React.createElement(Component, __assign({}, rest, { onKeyPress: (onEnter || onKeyPress) && handleOnKeyPress }));
}; };
exports.default = exports.withEnterKey;
//# sourceMappingURL=withEnterKey.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/hocs/input/withEnterKey.js
// module id = 916
// module chunks = 0